import * as React from 'react';

import Icon from '../../assets/icons/button-arrow.svg';

import {
	ScButton,
	ScButtonWithDropdownWrapper,
	ScDropdownDivider,
	ScDropdownItem,
	ScDropdownMenuItemsWrapper,
	ScDropdownMenuWrapper,
	ScDropdownTitle,
} from './styled';
import { ScDropdowListContainer } from '../header/styled';
import { IGroupItem } from '../footer/helpers';

interface IButton {
	color?: string;
	background?: string;
	border?: string;
	onClick?: () => void;
	children: JSX.Element | JSX.Element[] | string;
	hoverColor?: string;
	hoverBackground?: string;
	hoverBorder?: string;
	disabled?: boolean;
	font?: string;
	isArrow?: boolean;
	className?: string;
	dropdownItems?: { title: string; icon?: string; onClick?: () => void; group?: IGroupItem[] }[];
	isMenuItem?: boolean;
}

export const CustomButton = ({
	color,
	background,
	border,
	onClick,
	children,
	hoverColor,
	hoverBackground,
	hoverBorder,
	disabled = false,
	font,
	isArrow = false,
	className,
	dropdownItems,
	isMenuItem = false,
}: IButton) => {
	const [showDropdown, setShowDropdown] = React.useState(false);

	const handleMouseEnter = () => {
		setShowDropdown(true);
	};

	const handleMouseLeave = () => {
		setShowDropdown(false);
	};

	const withDropdown = !!dropdownItems && dropdownItems.length > 0;

	const getButton = (): JSX.Element => {
		return (
			<ScButton
				color={color}
				background={background}
				border={border}
				onClick={onClick}
				disabled={disabled}
				hoverColor={hoverColor}
				hoverBackground={hoverBackground}
				hoverBorder={hoverBorder}
				font={font}
				className={className}
			>
				{children}
				{isArrow && <img src={Icon} alt={'icon'} />}
			</ScButton>
		);
	};

	return !withDropdown ? (
		getButton()
	) : (
		<ScButtonWithDropdownWrapper
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			className={className}
		>
			{getButton()}
			{showDropdown && (
				<ScDropdowListContainer
					style={{
						position: 'absolute',
						top: '100%',
						margin: isMenuItem ? '15px 0px 0px -145px' : '15px 0px 0px -65px',
						width: isMenuItem ? '250px' : '200px',
					}}
				>
					{isMenuItem
						? dropdownItems?.map((item, index, array) => (
								<ScDropdownMenuWrapper key={index}>
									<ScDropdownTitle>
										{item?.icon && <img src={item.icon} alt={'menu_img'} className={'label-img'} />}
										{item.title}
									</ScDropdownTitle>
									<ScDropdownMenuItemsWrapper>
										{item.group?.map((groupItem, index) => (
											<ScDropdownItem key={index}>
												<a href={groupItem.link}>{groupItem.title}</a>
											</ScDropdownItem>
										))}
									</ScDropdownMenuItemsWrapper>
									{index < array.length - 1 && <ScDropdownDivider />}
								</ScDropdownMenuWrapper>
						  ))
						: dropdownItems?.map((item, index) => (
								<ScDropdownItem
									key={index}
									$isClickable={Boolean(item.onClick)}
									onClick={item.onClick && item.onClick}
								>
									{item.title}
								</ScDropdownItem>
						  ))}
				</ScDropdowListContainer>
			)}
		</ScButtonWithDropdownWrapper>
	);
};
